(function($) { 
	$.fn.fileUploadSet = function() {
		var _this = this;

		var fileUpload = {
			$el: null,
			fileInput: {
				$el: null,
				id: null,
				name: null
			},
			fileNameInput: {
				$el: null,
				id: null,
				name: null
			},
			$label: null,
			multiLength: null,
			uploadRowHtml: null,
			init: function($el){
				var _self = fileUpload;
				_self.$el = $el;

				_self.fileInput.$el = _self.$el.find('.replace-file-input input[type="file"]');
				_self.fileInput.id = _self.fileInput.$el.attr("id");
				_self.fileInput.name = _self.fileInput.$el.attr("name");

				_self.fileNameInput.$el = _self.$el.find("input.file-name-expose");
				_self.fileNameInput.id = _self.fileNameInput.$el.attr("id");
				_self.fileNameInput.name = _self.fileNameInput.$el.attr("name");

				_self.$label = $("label[for="+ _self.fileNameInput.id +"]");
				
				// multi file upload
				if(_self.$el.is("[data-multi-length]") && !isNaN(_self.$el.attr("data-multi-length"))){
					_self.multiLength = _self.$el.attr("data-multi-length") || 4;
					if(!_self.$label.find(".file-length").length){
						_self.$label.append("&nbsp;(<span class='file-length'>1</span>)");
					}
				}
				//LGEBR-1074
				if(_self.$el.find(".upload-file-container") && _self.$el.find(".upload-file-container").length > 0){
					if(_self.$el.find(".upload-file-container .upload-file-list li").length >= _self.multiLength){
						_self.$el.find(".delivery-part").addClass("unavailable");
						_self.$el.find(".field-block").first().find(".add-next").css("visibility","hidden");
						_self.fileInput.$el.prop("disabled",true)
					}else{
						if(_self.$el.find(".field-block").length+_self.$el.find(".upload-file-container .upload-file-list li").length == _self.multiLength){
							_self.$el.find(".field-block").first().find(".add-next").css("visibility","hidden");
						}else{
							_self.$el.find(".field-block").first().find(".add-next").css("visibility","visible");
						}
						_self.$el.find(".delivery-part").removeClass("unavailable")
						_self.fileInput.$el.prop("disabled",false)
					}
				}
				// hbs에서 입력되는 false 값 삭제
				_self.fileInput.$el.get(0).getAttribute("required") == "false" && _self.fileInput.$el.removeAttr("required").get(0).removeAttribute("required");
				_self.fileNameInput.$el.get(0).getAttribute("required") == "false" && _self.fileNameInput.$el.removeAttr("required").get(0).removeAttribute("required");

				_self.uploadRowClone(); // file upload line copy
				_self.fileAttrUpdate(); // file inputs attribute update   
				_self.$label.attr("for", _self.fileNameInput.id+"_1");
				
				_self.$el.addClass("fileupload-init");
				_self.uploadFileDel();
				_self.addEvent();
			},
			uploadFileDel: function(){
				var _self = fileUpload;
				var $uploadFileList = _self.$el.find(".upload-file-list");
				$uploadFileList.find("li").each(function(i){
					var $this = $(this);
					$this.on("click", ".btn-delete", function(){
						if($("#deleteFileNoList").val()==""){
							$("#deleteFileNoList").val($this.data("fileNo"));
						}else{
							$("#deleteFileNoList").val($("#deleteFileNoList").val()+","+$this.data("fileNo"));
						}
						$this.remove();
						_self.multiLength && _self.maxLengthCheck();
					})
				})
			},
			uploadRowClone: function(){
				var _self = fileUpload;

				var $uploadRow = _self.$el.find(".field-block");
				var uploadRowClone = $uploadRow.clone();

				uploadRowClone.find(".delivery-part").removeClass("available, attached");
				uploadRowClone.find(".add-next").removeClass("active").next(".delete-this").addClass("active");
				uploadRowClone.find("input[type='text'], input[type='file']").removeAttr("required");
				_self.uploadRowHtml = uploadRowClone[0].outerHTML;
			},
			maxLengthCheck: function(){
				var _self = fileUpload;

				var $uploadRow = _self.$el.find(".field-block");
				if(_self.$el.find(".upload-file-container").length >= 1){
					if(_self.$el.find(".upload-file-container .upload-file-list li").length >= _self.multiLength ){
						_self.$el.find(".delivery-part").addClass("unavailable")
						if(_self.$el.find(".upload-file-container .upload-file-list li").length  == _self.multiLength){
							_self.$el.find(".field-block").first().find(".add-next").css("visibility","hidden");
						}
					}else{
						$uploadRow.find("input[type='file']").removeAttr("disabled");
						_self.$el.find(".delivery-part").removeClass("unavailable");
					}
					$uploadRow.length = $uploadRow.length+_self.$el.find(".upload-file-container .upload-file-list li").length
				}
				if ($uploadRow.length >= _self.multiLength) {
					$uploadRow.first().find(".add-next").attr("disabled","disabled");
					if(_self.$el.find(".upload-file-container").length >= 1){
						_self.$el.find(".field-block").first().find(".add-next").css("visibility","hidden");
					}
				} else {
					$uploadRow.first().find(".add-next").removeAttr("disabled");
					if(_self.$el.find(".upload-file-container").length >= 1){
						_self.$el.find(".field-block").first().find(".add-next").css("visibility","visible");
					}
				}
				_self.$el.find("p.notice").css("visibility","hidden").last().css("visibility","visible");
				
			},
			fileAttrUpdate: function(){
				var _self = fileUpload;

				var $uploadRow = _self.$el.find(".field-block");
				$uploadRow.each(function(index){
					var $this = $(this);
					var indexNum = index + 1;
					$this.find("input[type='file']").data( _self.fileInput.$el.data() ); // data 값이 복제되지않는 문제 수정
					$this.find("input[type='file']").attr({
						"name": _self.fileInput.name+"_"+indexNum,
						"id": _self.fileInput.id+"_"+indexNum
					}).next("label").attr({
						"for": _self.fileInput.id+"_"+indexNum
					});
					$this.find(".file-name-expose").attr({
						"id": _self.fileNameInput.id+"_"+indexNum,
						"name": _self.fileNameInput.name+"_"+indexNum
					});
				});
				_self.$label.find(".file-length").text($uploadRow.length);
			},
			addEvent: function(){
				var _self = fileUpload;

				// File upload 시 validation 체크
				_self.$el.on("change", "input[type='file']", function(e){
					$(this).checkValidation(); // form-validation.js checkValidation
				});

				// add file upload
				_self.$el.on("click", ".add-next", function(){
					_self.$el.find(".field-block").last().after(_self.uploadRowHtml);
					_self.multiLength && _self.maxLengthCheck();
					_self.fileAttrUpdate();
					bindFileUpload( _self.$el.find(".field-block").last().find(".delivery-part") ); // common.js bindFileUpload
				});

				// remove file upload
				_self.$el.on("click", ".delete-this", function(){
					//LGCOMCS-90 START
					var videoUseFlag = _self.$el.find('input[type="file"]').data('video-use-flag') || 'N',
						videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'hevc', 'wmv'],
						fileInputs = document.getElementsByClassName('fileupload'),
						allFiles = [],
						videoCount = 0;
					
					if(videoUseFlag == 'Y'){
						for (var i = 0; i < fileInputs.length; i++) {
							var input = fileInputs[i];
							if (input.files && input.files.length > 0) {
								allFiles.push(input.files[0]);
							}
						}
	
						for (var j = 0; j < allFiles.length; j++) {
							var videoFile = allFiles[j];
							var videoFileName = videoFile.name;
							var videoExt = videoFileName.substring(videoFileName.lastIndexOf('.') + 1).toLowerCase();
	
							if (videoExtensions.includes(videoExt)) {
								videoCount++;
							}
						}
						
						if(videoCount == 2){
							$('.videoCount').hide().closest('.error').removeClass('error');
						}
					}
					//LGCOMCS-90 END
					
					$(this).closest(".field-block").remove();
					_self.multiLength && _self.maxLengthCheck();
					_self.fileAttrUpdate();
				});
			},
		};

		_this.each(function() {
			!$(this).hasClass("fileupload-init") && fileUpload.init($(this));
		});
	};
})(jQuery);